export default __webpack_public_path__ + "static/media/placeholder.51c84f9e.png";